import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let chair_id = useDataValue({
    context: 'tab',
    path: 'scheduling.untemplated_slot.chair_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      chair_id,
    },
  }
}
